class RTTierBar extends HTMLElement {
  constructor() {
    super();
    this.cartTotal = parseFloat(this.dataset.cartTotal || 0);
    this.cartCurrency = this.dataset.cartCurrency || 'USD';
    this.message100 = this.dataset.message100 || "You're earning [[discount]]% off your order!";
    this.tiers = [];
    this.currentTier = null;
    this.nextTier = null;

    this.init();
  }

  init() {
    console.log('='.repeat(50));
    console.log('🚀 INITIALIZING RT TIER BAR 🚀');
    console.log('='.repeat(50));
    this.parseTiers();
    this.render();
    this.updateProgress();
  }

  parseTiers() {
    const jsonScript = this.querySelector('#rt-tier-bar-json');
    if (!jsonScript) return;

    try {
      const tierData = jsonScript.textContent.trim();
      // Parse the comma-separated JSON objects
      const tierObjects = tierData.split(/},\s*{/).map((str, index, arr) => {
        if (index === 0) str += '}';
        else if (index === arr.length - 1) str = '{' + str;
        else str = '{' + str + '}';
        return JSON.parse(str);
      });

      this.tiers = tierObjects
        .map(tier => ({
          threshold: parseFloat(tier.tier),
          discount: parseInt(tier.discount),
          message: tier.message,
        }))
        .sort((a, b) => a.threshold - b.threshold);
    } catch (e) {
      console.error('Failed to parse tier data:', e);
    }
  }

  getCurrentAndNextTier() {
    let current = this.tiers[0];
    let next = null;

    for (let i = 0; i < this.tiers.length; i++) {
      if (this.cartTotal >= this.tiers[i].threshold) {
        current = this.tiers[i];
        next = this.tiers[i + 1] || null;
      } else {
        next = this.tiers[i];
        break;
      }
    }

    this.currentTier = current;
    this.nextTier = next;
  }

  calculateProgress() {
    if (!this.tiers.length) return 0;

    // If cart total is below the first tier
    const firstTier = this.tiers[0];
    if (this.cartTotal < firstTier.threshold) {
      return (this.cartTotal / firstTier.threshold) * 100;
    }

    // If cart total is at or above the last tier
    const lastTier = this.tiers[this.tiers.length - 1];
    if (this.cartTotal >= lastTier.threshold) {
      return 100;
    }

    // Find the position between tiers
    const totalRange = lastTier.threshold - firstTier.threshold;
    const currentPosition = this.cartTotal - firstTier.threshold;
    const progress = (currentPosition / totalRange) * 100;

    return Math.min(Math.max(progress, 0), 100);
  }

  formatCurrency(amount) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: this.cartCurrency,
    }).format(amount);
  }

  getProgressMessage() {
    if (!this.nextTier || this.calculateProgress() === 100) {
      return this.message100.replace('[[discount]]', this.currentTier.discount);
    }

    const remaining = this.nextTier.threshold - this.cartTotal;
    return `You are $${remaining.toFixed(2)} away from ${this.nextTier.discount}% off`;
    // return this.nextTier.message;
  }

  render() {
    this.getCurrentAndNextTier();

    const container = document.createElement('div');
    container.className = 'rt-tier-bar__container';

    // Message
    const message = document.createElement('p');
    message.className = 'rt-tier-bar__message';
    message.textContent = this.getProgressMessage();

    // Progress bar
    const progressContainer = document.createElement('div');
    progressContainer.className = 'rt-tier-bar__progress';

    const progressFill = document.createElement('div');
    progressFill.className = 'rt-tier-bar__fill';

    // Tooltip for current spend
    const tooltip = document.createElement('div');
    tooltip.className = 'rt-tier-bar__tooltip';
    tooltip.textContent = this.formatCurrency(this.cartTotal).replace('.00', '');

    progressContainer.appendChild(progressFill);
    progressContainer.appendChild(tooltip);

    // Tier markers
    const tierMarkers = document.createElement('div');
    tierMarkers.className = 'rt-tier-bar__tiers';

    if (this.tiers.length > 0) {
      const lastTier = this.tiers[this.tiers.length - 1];
      const marker = document.createElement('span');
      marker.textContent = this.formatCurrency(lastTier.threshold).replace('.00', '');
      tierMarkers.appendChild(marker);
    }

    container.appendChild(message);
    container.appendChild(progressContainer);
    // container.appendChild(tierMarkers);

    // Clear existing content (except noscript)
    const noscript = this.querySelector('#rt-tier-bar-json');
    this.innerHTML = '';
    if (noscript) this.appendChild(noscript);
    this.appendChild(container);
  }

  updateProgress() {
    const progressFill = this.querySelector('.rt-tier-bar__fill');
    const tooltip = this.querySelector('.rt-tier-bar__tooltip');

    if (progressFill && tooltip) {
      const progress = this.calculateProgress();
      progressFill.style.setProperty('width', `${progress}%`);

      // Position tooltip based on progress
      const tooltipPosition = Math.max(10, Math.min(98, progress)); // Keep between 10% and 98%
      tooltip.style.setProperty('--tooltip-position', `${tooltipPosition}%`);
      tooltip.style.left = `${tooltipPosition}%`;
      if (progress > 98 || progress === 0) {
        tooltip.classList.add('full');
        tooltip.style.display = 'none';
      } else {
        tooltip.classList.remove('full');
        tooltip.style.display = 'block';
      }
    }
  }

  // Method to update cart total externally
  updateCartTotal(newTotal) {
    this.cartTotal = parseFloat(newTotal);
    this.dataset.cartTotal = newTotal;

    const message = this.querySelector('.rt-tier-bar__message');
    if (message) {
      message.textContent = this.getProgressMessage();
    }

    // Update tooltip with new cart total
    const tooltip = this.querySelector('.rt-tier-bar__tooltip');
    if (tooltip) {
      tooltip.textContent = this.formatCurrency(this.cartTotal).replace('.00', '');
    }

    this.updateProgress();
  }
}

customElements.define('rt-tier-bar', RTTierBar);